@if (!showStatusBar) {
  <div class="report-box" #report_box [style.width.px]="width_report_box" (mouseout)="onOutContainer()" (mouseover)="onOverContainer()">
    <ul class="report-list-box" >
      <!-- Workers Back Reports -->
      @for (process of list_process; track trackByJobId($index, process)) {
        @if (process.job_type != 'progress') {
          <li
            [ngClass]="{'report-done': process.status == 'complete', 'report-fail': process.status == 'failed'}"  #report_name_list>
            <a target="_blank" [href]="process.url || process.redirect || process.data?.web_url">
              <span class="report-name">
                @if (process.status != 'complete') {
                  <span #report_name>
                    {{ 'Generating' | translate}} {{ process.job_type }} {{ process.job_name | translate}}
                    {{ process.valid | date: 'yyyy-MM-dd H:m a'}}
                  </span>
                }
                @if (process.status == 'complete') {
                  <span #report_name>
                    <img src="assets/img/download.gif"> {{ process.job_type }} {{ process.job_name | translate}}
                    {{ process.valid | date: 'yyyy-MM-dd H:m a'}}
                  </span>
                }
              </span>
              <div (click)="deleteProcess($event, process)" class="report-status">X</div>
            </a>
          </li>
        }
      }
      <!-- Front background processes -->
      @for (file of list_files; track file) {
        <li [ngClass]="{'report-done': file.status == 'complete', 'report-fail': file.status == 'failed'}"  #file_name_list>
          @if (file.action == 'view') {
            <a target="_blank" [href]="file.url">
              <span class="report-name">
                @if (file.status != 'complete') {
                  <span #file_name>
                    {{ 'Uploading' | translate}} - {{ file.fileName }}
                  </span>
                }
                @if (file.status == 'complete') {
                  <span #file_name>
                    {{ file.fileName }}
                  </span>
                }
              </span>
              @if (file.status != 'pending') {
                <div (click)="deleteFile($event, file)" class="report-status">X</div>
              }
            </a>
          }
          @if (file.action == 'download') {
            <a target="_blank" [href]="file.url" (click)="downloadReport($event, file)" >
              <span class="report-name">
                @if (file.status != 'complete') {
                  <span #file_name>
                    {{ 'Generating' | translate}} - {{ file.fileName }}
                  </span>
                }
                @if (file.status == 'complete') {
                  <span #file_name>
                    <img src="assets/img/download.gif">
                    {{ file.fileName }}
                  </span>
                }
              </span>
              @if (file.status != 'pending') {
                <div (click)="deleteFile($event, file)" class="report-status">X</div>
              }
            </a>
          }
        </li>
      }
    </ul>
  </div>
  <!-- Duplicate projects window -->
  <div class="duplicate-project" #duplicateBox>
    <ul class="report-list-box">
      @for (process of list_process; track trackByJobId($index, process)) {
        @if (process.job_type == 'progress') {
          <li [ngClass]="{'report-done': process.status == 'complete', 'report-fail': process.status == 'failed', 'expanded': process.isOpen}">
            @if (process.status == 'complete') {
              <span class="material-icons left-icon">check</span>
            }
            @if (process.status != 'complete') {
              <span class="material-icons left-icon">autorenew</span>
            }
            @if (!process.isOpen) {
              <div class="icon-wrapper right-icon">
                <span (click)="toggleViewProcess(process)"  class="material-icons right-icon">keyboard_arrow_right</span>
              </div>
            }
            @if (process.isOpen) {
              <span class="report-name">
                @if (process.status != 'complete') {
                  <span>
                    {{'Duplicating project' | translate}}: {{ process.job_name}}
                  </span>
                }
                @if (process.status == 'complete') {
                  <span>
                    {{'Duplicated project' | translate}}: {{ process.job_name}}
                  </span>
                }
                <span class="percentage">
                  {{process.progress_percentage ? process.progress_percentage : 0}}%
                </span>
              </span>
              <div class="icon-wrapper">
                @if (process.status == 'complete') {
                  <span (click)="deleteProcess($event, process)" class="material-icons right-icon close">close</span>
                }
                @if (process.status != 'complete') {
                  <span (click)="toggleViewProcess(process)"  class="material-icons right-icon">keyboard_arrow_left</span>
                }
              </div>
            }
          </li>
        }
      }
    </ul>
  </div>
}
@if (showStatusBar) {
  <div class="report-box-progress">
    <ul class="progress-list-box">
      @for (process of list_process; track trackByJobId($index, process)) {
        <li>
          <a style="color: white; text-decoration: none;" target="_blank" [href]="process.url || process.redirect || process.data?.web_url">
            <div style="display: inline;">
              @if (!process.status || process?.status == 'queued' || process?.status == 'working') {
                <span>{{'Uploading' | translate}} {{ $safeNavigationMigration(process?.name_upload) | translate }}...</span>
              }
              @if (process?.status == 'complete') {
                <span>{{'Complete' | translate}}</span>
              }
              @if (process?.status == 'failed') {
                <span>{{'Failed' | translate}}</span>
              }
            </div>
            <div (click)="deleteProcess($event, process)" class="close-progress">X</div>
            <div class="worker-progress-bar">
              <div class="centered-content">
                @if (process.status != 'complete') {
                  <span #report_name>
                    {{ 'Generating' | translate}} {{ process.job_type }} {{ process.job_name | translate}}
                    {{ process.valid | date: 'yyyy-MM-dd H:m a'}} ({{ process?.data?.pct_complete ? process?.data?.pct_complete : '0' }}%)
                  </span>
                }
                @if (process.status == 'complete') {
                  <span #report_name>
                    {{ process.job_type }} {{ process.job_name | translate}}
                    {{ process.valid | date: 'yyyy-MM-dd H:m a'}} ({{ process?.data?.pct_complete ? process?.data?.pct_complete : '0' }}%)
                  </span>
                }
                <div class="progress" [ngStyle]="{ 'width.%': process?.data?.pct_complete ? process.data.pct_complete : 0 }" [ngClass]="{'bg-green': process?.status != 'failed', 'bg-red': process?.status == 'failed'}">
                </div>
              </div>
            </div>
          </a>
        </li>
      }
    </ul>
  </div>
}